import { Button } from '@material-ui/core'
import { FileUpload } from '@styled-icons/material-outlined/FileUpload'
import BackButton from 'components/BackButton'
import NomeTerreno from 'components/NomeTerreno'
import Loading from 'components/Loading'
import CartaoDadosGerais from 'components/Viabilidades/ResultadoViabilidade/CartaoDadosGerais'
import CardFormaDePagamento from 'components/Viabilidades/ResultadoViabilidade/CartaoFormaDePagamento'
import { CasasSaida } from 'models/Viabilidade/CasasSaida'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import * as S from './index.style'
import CartaoDatas from 'components/Viabilidades/ResultadoViabilidade/CartaoDatas'
import CartaoGarantias from 'components/Viabilidades/ResultadoViabilidade/CartaoGarantias'
import CartaoFinanceiro from 'components/Viabilidades/ResultadoViabilidade/CartaoFinanceiro'
import CartaoDre from 'components/Viabilidades/ResultadoViabilidade/CartaoDre'
import CartaoIndicadores from 'components/Viabilidades/ResultadoViabilidade/CartaoIndicadores'
import CartaoComercial from 'components/Viabilidades/ResultadoViabilidade/CartaoComercial'
import CartaoTributacao from 'components/Viabilidades/ResultadoViabilidade/CartaoTributacao'
import CartaoConstrucao from 'components/Viabilidades/ResultadoViabilidade/CartaoConstrucao'
import CartaoUrbanizacao from 'components/Viabilidades/ResultadoViabilidade/CartaoUrbanizacao'
import CartaoDetalhamentoProjeto from 'components/Viabilidades/ResultadoViabilidade/CartaoDetalhamentoProjeto'
import CartaoDescontos from 'components/Viabilidades/ResultadoViabilidade/CartaoDescontos'
import Cartao from 'components/Cartao'
import { useEffect } from 'react'
import { Guid } from 'guid-typescript'
import React from 'react'
import { buscarViabilidadePorId, downloadViabilidadeCasas, tornarVigenteViabilidadeCasas } from 'services/viabilidadeCasas.service'
import ModalClonarViabilidade from 'components/ModalClonarViabilidade'
import Progress from 'components/Progress'
import { processandoDados } from 'helpers/Constantes/Mensagens'
import { RetornoApiGenerics } from 'models/Geral/RetornoApiGenerics'
import { useSnackbar } from 'components/SnackBar/'
import { PdfDto } from 'models/Viabilidade/PdfDto'
import { Box } from '@material-ui/core'
import Erro from 'components/Erro'
import { TipoSituacaoEnum } from 'models/Viabilidade/Enum/TipoSituacaoEnum'
import { ContentCopy } from '@styled-icons/material-outlined/ContentCopy'
import { Edit } from '@styled-icons/material-rounded'
import CartaoLoteadora from 'components/Viabilidades/ResultadoViabilidade/CartaoLoteadora'
import { TipoProjetoEnum } from 'models/Viabilidade/Enum/TipoProjetoEnum'
import { ModeloNegocioEnum } from 'models/Viabilidade/Enum/ModeloNegocioEnum'
import { EstadoModalEnum } from 'models/Viabilidade/Enum/EstadoModalEnum'
import { ConfirmModal } from 'components/ConfirmModal'

export interface IStateLocation {
  nomeTerreno: string
  idViabilidade: string
  token: string
  resultadoViabilidade?: CasasSaida
  situacao: TipoSituacaoEnum
  areaTerreno: number | undefined
  dataCompraTerreno: string | undefined
  fase: number
  idEmpreendimento?: string | null
}

export interface IResultadoViabilidadeRoutParams {
  idTerreno: string
  idViabilidade: string
}

export const ResultadoViabilidade: React.FC = () => {
  const snackBar = useSnackbar()
  const history = useHistory()
  const { state } = useLocation<IStateLocation>()
  const { idTerreno } = useParams<IResultadoViabilidadeRoutParams>()
  const [resultadoViabilidade, setResultadoViabilidade] = React.useState<CasasSaida>()
  const [loading, setLoading] = React.useState(false)
  const [mostrarModalClonar, setMostrarModalClonar] = React.useState(false)
  const [ocorreuErro, setOcorreuErro] = React.useState(false)
  const [situacaoViabilidade, setSituacaoViabilidade] = React.useState(state.situacao)
  const [estadoModalTornarVigente, setEstadoModalTornarVigente] = React.useState(EstadoModalEnum.Fechado)

  useEffect(() => {
    const buscarViabilidade = async (idViabilidade: Guid) => {
      await buscarViabilidadePorId(idViabilidade)
        .then((respostaApi) => {
          setResultadoViabilidade(respostaApi.entity)
        })
        .catch(() => {
          setOcorreuErro(true)
        })
    }
    if (!state.resultadoViabilidade) {
      buscarViabilidade(Guid.parse(state.idViabilidade))
    } else {
      setResultadoViabilidade(state.resultadoViabilidade)
    }
  }, [state.idViabilidade, state.resultadoViabilidade])

  const goToViabilidade = () => {
    const paramIdEmpreendimento = state.idEmpreendimento ? `&idEmpreendimento=${state.idEmpreendimento}` : ''
    history.push(`/terrenos/${idTerreno}/viabilidades?fase=${state.fase}${paramIdEmpreendimento}&token=${state.token}`)
  }

  const baixarViabilidade = (base64: string) => {
    const linkSource = `data:application/pdf;base64,${base64}`
    const filename = `${resultadoViabilidade?.dadosGerais.nomeViabilidade}.pdf`
    downloadArquivo(linkSource, filename)
  }

  const downloadArquivo = (linkSource: string, filename: string) => {
    const downloadLink = document.createElement('a')
    downloadLink.href = linkSource
    downloadLink.download = filename
    downloadLink.click()
  }

  const exportarViabilidade = async () => {
    setLoading(true)
    snackBar.showInfo('Processando os dados...', '60px')
    const idViabilidade = resultadoViabilidade ? resultadoViabilidade.id : state.idViabilidade
    await downloadViabilidadeCasas(Guid.parse(idViabilidade))
      .then((respostaApi: RetornoApiGenerics<PdfDto>) => {
        if (respostaApi.entity?.base64) {
          baixarViabilidade(respostaApi.entity.base64)
          snackBar.showSuccess('Viabilidade exportada com sucesso!', '60px')
        } else {
          snackBar.showError('Não foi possível realizar sua solicitação. Tente novamente mais tarde.', '60px')
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
        setOcorreuErro(true)
      })
  }

  const abrirModalClonarViabilidade = () => {
    setMostrarModalClonar(!mostrarModalClonar)
  }

  const goToPageNovaViabilidade = () => {
    history.push('nova-viabilidade', {
      nomeTerreno: state.nomeTerreno,
      areaTerreno: state.areaTerreno,
      dataCompraTerreno: state.dataCompraTerreno,
      token: state.token,
      idViabilidade: state.idViabilidade,
      situacaoViabilidade: TipoSituacaoEnum.Rascunho,
      fase: state.fase,
      idEmpreendimento: state.idEmpreendimento
    })
  }

  const fecharModalClonarViabilidade = () => {
    setMostrarModalClonar(false)
  }

  const buttonBorder = { border: 'solid 1px #54BC82', color: '#079D56' }

  const abrirModalTornarViabilidadeVigente = () => {
    setEstadoModalTornarVigente(EstadoModalEnum.Confirmacao)
  }

  const fecharModalTornarViabilidadeVigente = () => {
    setEstadoModalTornarVigente(EstadoModalEnum.Fechado)
  }

  const confirmarModalTornarViabilidadeVigente = async () => {
    setEstadoModalTornarVigente(EstadoModalEnum.Loading)
    await tornarVigenteViabilidadeCasas(Guid.parse(state.idViabilidade))
      .then((respostaApi: { isSuccess: boolean; entity: unknown }) => {
        const resposta = respostaApi.entity as boolean
        if (resposta) {
          setEstadoModalTornarVigente(EstadoModalEnum.Sucesso)
        } else {
          setEstadoModalTornarVigente(EstadoModalEnum.Erro)
        }
      })
      .catch(() => {
        setEstadoModalTornarVigente(EstadoModalEnum.Erro)
      })
  }

  const concluirModalTornarViabilidadeVigente = () => {
    setSituacaoViabilidade(TipoSituacaoEnum.Vigente)
    fecharModalTornarViabilidadeVigente()
  }

  const podeSerVigente = (): boolean => {
    const temEmpreendimento = state.idEmpreendimento && state.idEmpreendimento !== 'null' && state.idEmpreendimento !== ''
    const eSimuladoOuVigente = situacaoViabilidade === TipoSituacaoEnum.Simulado || situacaoViabilidade === TipoSituacaoEnum.Vigente

    if (temEmpreendimento && eSimuladoOuVigente) return true

    return false
  }

  return (
    <S.Wrapper>
      <S.Cabecalho>
        <S.Voltar>
          <BackButton titulo="Viabilidade Simulada" onClick={goToViabilidade} />
        </S.Voltar>
        <S.Terreno>
          <NomeTerreno nomeTerreno={state?.nomeTerreno} cor="verde" />
        </S.Terreno>
        <S.DataSimulacao data-cy="dataSimulacao">Data da simulação: {new Intl.DateTimeFormat('pt-BR').format(new Date())}</S.DataSimulacao>
        <S.BoxCustomizada sx={{ m: 1, position: 'relative' }}>
          {podeSerVigente() && (
            <Box sx={{ position: 'relative' }}>
              <S.BotaoVigente
                data-cy="btnTornarVigente"
                variant="contained"
                startIcon={<S.IconeVigente size={20} />}
                disableElevation={true}
                disabled={situacaoViabilidade == TipoSituacaoEnum.Vigente}
                onClick={abrirModalTornarViabilidadeVigente}
              >
                {situacaoViabilidade === TipoSituacaoEnum.Vigente ? 'Vigente' : 'Tornar Vigente'}
              </S.BotaoVigente>
            </Box>
          )}

          {estadoModalTornarVigente != EstadoModalEnum.Fechado && (
            <ConfirmModal
              funcaoConfirmar={confirmarModalTornarViabilidadeVigente}
              funcaoCancelar={fecharModalTornarViabilidadeVigente}
              funcaoOk={concluirModalTornarViabilidadeVigente}
              estadoModal={estadoModalTornarVigente}
              titulo={'Tornar viabilidade vigente'}
              botaoConfirmacao={'Tornar vigente'}
              botaoCancelar={'Cancelar'}
              textoSucesso={'O status da viabilidade foi alterado para "Vigente" com sucesso!'}
              textoErro={'Ocorreu um erro ao tonrar essa viabilidade vigente.'}
            >
              <S.TextoModalTornarVigente>
                Deseja mesmo tornar essa viabilidade vigente? <br />
                Essa ação fará com que outra viabilidade &quot;Vigente&quot; volte ao status &quot;Simulada&quot;.
              </S.TextoModalTornarVigente>
            </ConfirmModal>
          )}

          <Button
            data-cy="btnDuplicarTelaResultado"
            variant="contained"
            style={buttonBorder}
            startIcon={<ContentCopy size={20} color="#079D56" />}
            disableElevation={true}
            disabled={loading}
            onClick={abrirModalClonarViabilidade}
          >
            Duplicar
          </Button>

          {mostrarModalClonar && (
            <ModalClonarViabilidade
              idViabilidade={state?.idViabilidade}
              situacaoViabilidade={state?.situacao}
              aberto={mostrarModalClonar}
              closeDialogClonarViabilidade={fecharModalClonarViabilidade}
              nomeTerreno={state?.nomeTerreno}
              areaTerreno={state?.areaTerreno}
              dataCompraTerreno={state?.dataCompraTerreno}
              token={state?.token}
              fase={state.fase}
              idEmpreendimento={state?.idEmpreendimento}
            />
          )}

          {state.situacao != TipoSituacaoEnum.Aprovado && (
            <Button
              data-cy="btnEditarTelaResultado"
              variant="contained"
              style={buttonBorder}
              startIcon={<Edit size={20} color="#079D56" />}
              disableElevation={true}
              disabled={loading}
              onClick={goToPageNovaViabilidade}
            >
              Editar
            </Button>
          )}
        </S.BoxCustomizada>
      </S.Cabecalho>

      {ocorreuErro ? (
        <S.WrapperFixed>
          <Erro />
        </S.WrapperFixed>
      ) : resultadoViabilidade ? (
        <>
          <S.Principal>
            <CartaoDadosGerais dadosGerais={resultadoViabilidade.dadosGerais} data-cy="cartaoDadosGerais"></CartaoDadosGerais>
          </S.Principal>

          <S.CartoesWrapper>
            <S.ColunaCartoes>
              <Cartao titulo="Datas">
                <CartaoDatas dados={resultadoViabilidade.dadosCompraTerreno.datas} />
              </Cartao>

              {resultadoViabilidade.dadosGerais.tipoProjeto === TipoProjetoEnum.LoteamentoAberto && (
                <>
                  <Cartao titulo="Loteadora">
                    <CartaoLoteadora dados={resultadoViabilidade.loteadora} />
                  </Cartao>
                </>
              )}

              {(resultadoViabilidade.dadosGerais.tipoProjeto === TipoProjetoEnum.CondominioIncorporacao ||
                resultadoViabilidade.dadosGerais.modeloNegocio === ModeloNegocioEnum.MrvAdquirenteLote) && (
                <>
                  <Cartao titulo="Forma de Pagamento" data-cy="cartaoFormaPagamento">
                    <CardFormaDePagamento dados={resultadoViabilidade.formaPagamento} />
                  </Cartao>

                  <Cartao titulo="Garantias" data-cy="cartaoGarantias">
                    <CartaoGarantias dados={resultadoViabilidade.dadosCompraTerreno.garantias} />
                  </Cartao>
                </>
              )}

              <Cartao titulo="Financeiro">
                <CartaoFinanceiro dados={resultadoViabilidade.financeiro} />
              </Cartao>

              <Cartao titulo="Comercial">
                <CartaoComercial dados={resultadoViabilidade.comercial} />
              </Cartao>

              <Cartao titulo="Descontos">
                <CartaoDescontos dados={resultadoViabilidade.descontos} />
              </Cartao>

              {resultadoViabilidade.dadosGerais.modeloNegocio === ModeloNegocioEnum.ParceriaLoteadora && (
                <Cartao titulo="Construção">
                  <CartaoConstrucao dados={resultadoViabilidade.construcao} />
                </Cartao>
              )}
            </S.ColunaCartoes>

            <S.ColunaCartoes>
              <Cartao titulo="Dre">
                <CartaoDre dados={resultadoViabilidade.dre} />
              </Cartao>

              <Cartao titulo="Indicadores">
                <CartaoIndicadores dados={resultadoViabilidade.indicadores} custoCasa={resultadoViabilidade.construcao?.custoCasa} />
              </Cartao>

              <Cartao titulo="Tributação">
                <CartaoTributacao dados={resultadoViabilidade.tributacao} />
              </Cartao>

              {(resultadoViabilidade.dadosGerais.tipoProjeto === TipoProjetoEnum.CondominioIncorporacao ||
                resultadoViabilidade.dadosGerais.modeloNegocio === ModeloNegocioEnum.MrvAdquirenteLote) && (
                <Cartao titulo="Construção">
                  <CartaoConstrucao dados={resultadoViabilidade.construcao} />
                </Cartao>
              )}

              <Cartao titulo="Urbanização">
                <CartaoUrbanizacao dados={resultadoViabilidade.urbanizacao} />
              </Cartao>
            </S.ColunaCartoes>

            <Cartao titulo="Detalhamento de Projeto">
              <CartaoDetalhamentoProjeto
                dados={resultadoViabilidade.detalhamentoProjeto}
                tipoProjeto={resultadoViabilidade.dadosGerais.tipoProjeto}
              ></CartaoDetalhamentoProjeto>
            </Cartao>
          </S.CartoesWrapper>

          <S.Rodape>
            <Button variant="outlined" onClick={goToViabilidade} data-cy="btnVoltar">
              Voltar p/ Lista
            </Button>
            <Box sx={{ m: 1, position: 'relative' }}>
              <Button
                data-cy="btnExportar"
                variant="contained"
                startIcon={<FileUpload size={18} />}
                disableElevation={true}
                disabled={loading}
                onClick={(event) => {
                  event.stopPropagation()
                  exportarViabilidade()
                }}
              >
                Exportar
              </Button>
              {loading && <Loading />}
            </Box>
          </S.Rodape>
        </>
      ) : (
        <S.WrapperFixed>
          <Progress label={processandoDados} />
        </S.WrapperFixed>
      )}
    </S.Wrapper>
  )
}
